module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  abstract: 'Simply Say - Buy greeting cards and gifts for all occasions. Customers can choose from a selection of designs or create their own.',
  title: 'Greeting Cards & Gifts | Simply Say', // Navigation and Site Title
  titleAlt: 'Greeting Cards & Gifts | Simply Say', // Title for JSONLD
  description: 'Looking for greeting cards in Singapore? Simply Say offers pre-designed cards from a range of categories. Using our card creator, you can even design you own using artwork, photos, emojis and more.',  
  url: 'https://www.simplysay.com', // Domain of your site. No trailing slash!
  siteUrl: 'https://www.simplysay.com/', // url + pathPrefix
  siteLanguage: 'en', // Language Tag on <html> element  
  image: '/images/logo/logo.png', // Used for SEO  
  // JSONLD / Manifest
  favicon: 'static/images/logo/favicon.png', // Used for manifest favicon generation
  shortName: 'SimplySay', // shortname for manifest. MUST be shorter than 12 characters
  author: 'Simply Say', // Author for schemaORGJSONLD
  themeColor: '#3e7bf2',
  backgroundColor: '#d3e0ff',
  twitterUsername: 'simplysay',
  copyrightText: (year) => `© ${year} Simply Say Pte Ltd.`,  
};
